export interface Article {
  id: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  image: string;
  views: number;
  isHot?: boolean;
  isNew?: boolean;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: '1',
    title: '某千万粉丝网红出轨实锤！酒店监控曝光，正牌男友现场捉奸',
    summary: '某平台千万级粉丝网红被爆出轨，酒店走廊监控完整记录其与他人进入房间的全过程。正牌男友携带朋友前往酒店，在房间外蹲守三小时后成功捉奸，现场视频引发全网热议。',
    content: '近日，一则关于某千万粉丝级别的头部网红出轨的爆料在各大社交平台疯狂传播，引发网友热议。\n\n据爆料人（该网红交往两年的正牌男友）提供的资料显示，事情发生在上周三深夜。该网红以"外出拍摄"为由离开住所，实际上却与另一名男子在某五星级酒店开房。\n\n男友因察觉异常，通过定位软件发现女友位置与所述不符，随即召集两名朋友前往该酒店。在酒店走廊蹲守近三个小时后，成功堵住了从房间走出的两人。\n\n现场流出的视频显示，被捉奸的男子试图从消防通道逃离，但被男友的朋友拦下。双方发生激烈口角，场面一度失控。该网红全程低头不语，试图用帽子和口罩遮挡面部。\n\n爆料人还提供了多段聊天记录截图，显示该网红与涉事男子早在三个月前就已经开始暧昧互动，并多次相约见面。更令人震惊的是，聊天记录中显示该网红同时与多名男性保持着不正当关系。\n\n目前，该网红尚未对此事作出正式回应，其个人社交平台已经关闭评论功能。但相关话题已经登上热搜榜首，阅读量突破3.2亿。',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    author: '51爆料君',
    date: '2026-07-01',
    image: 'https://readdy.ai/api/search-image?query=Hotel%20corridor%20at%20night%20with%20dramatic%20dark%20lighting%2C%20surveillance%20camera%20aesthetic%2C%20tense%20atmosphere%2C%20warm%20neon%20tones%20reflected%20on%20floor%2C%20editorial%20photography%20style%2C%20cinematic%20mood&width=800&height=500&seq=article-01&orientation=landscape',
    views: 3245600,
    isHot: true,
    tags: ['网红出轨', '酒店捉奸', '实锤', '监控视频'],
  },
  {
    id: '2',
    title: '顶流男星隐婚生子实锤！亲子鉴定报告流出，粉丝集体塌房',
    summary: '娱乐圈再爆惊天大瓜！某顶流男星被曝已隐婚三年并育有一子，亲子鉴定报告和相关文件被网友曝光。该男星此前一直以"单身人设"营业，此次塌房事件导致大量粉丝脱粉。',
    content: '娱乐圈又出惊天大瓜！某一线顶流男星被曝已经隐婚三年，并且育有一个两岁多的儿子。这一消息如同平地惊雷，瞬间引爆全网。\n\n爆料人提供了盖有某司法鉴定中心公章的亲子鉴定报告扫描件，报告显示该男星与一名男童存在生物学父子关系。此外，爆料人还出示了该男童的出生医学证明，上面父亲一栏填写的就是该男星的本名。\n\n据悉，该男星于2023年初与圈外女友秘密登记结婚。为了保护妻子和孩子的隐私，两人选择不对外公开。但随着孩子即将入读幼儿园，相关文件需要在多个场合使用，才导致消息走漏。\n\n该男星此前在多个综艺节目中均以"单身"形象出现，甚至曾表示"工作太忙没有时间谈恋爱"。其工作室多次发布单身声明，粉丝也将其奉为"国民老公"。此次塌房事件后，其个人超话瞬间涌入数万条脱粉宣言。\n\n值得关注的是，该男星代言的多个品牌已经紧急下架相关宣传物料。据业内人士透露，涉及违约赔偿金额可能高达数千万。该男星主演的待播剧也面临换角风险。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '娱乐圈速递',
    date: '2026-06-30',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20silhouette%20of%20male%20celebrity%20figure%20with%20paparazzi%20flashlights%2C%20dark%20moody%20atmosphere%2C%20red%20and%20orange%20tones%2C%20cinematic%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=article-02&orientation=landscape',
    views: 5612300,
    isHot: true,
    isNew: true,
    tags: ['顶流男星', '隐婚', '塌房', '亲子鉴定'],
  },
  {
    id: '3',
    title: '女大学生举报导师性骚扰，完整录音曝光，学校连夜回应',
    summary: '某985高校在读女硕士实名举报导师长期性骚扰，并公布了长达47分钟的录音证据。录音内容涉及导师多次言语暗示和不当身体接触，该女生称已忍受近两年。学校官方凌晨三点发布声明，表示已成立专项调查组。',
    content: '某知名985高校在读硕士研究生张某某（化名）昨日在某社交平台发布长文，实名举报其导师李某某教授存在长期性骚扰行为，并附上了长达47分32秒的录音证据。\n\n据张某某描述，自2024年9月入学以来，导师李某某多次在单独指导时对其进行言语骚扰，内容不堪入耳。更过分的是，导师还以"学术前途"为由，多次对她进行不当身体接触。\n\n张某某提供的录音文件清晰记录了导师的言语内容，其中包括多次要求张某某"到家里单独辅导"、"只要听话就能保证顺利毕业"等威胁性言论。另有数段录音记录了导师在办公室内对张某某进行强行拥抱和抚摸的声音。\n\n"我忍了快两年，每次告诉自己再坚持一下就能毕业。但最近导师越来越过分，甚至威胁如果我不同意就延期我的毕业。"张某某在长文中写道。\n\n事件曝光后，该高校官方账号于凌晨3:17发布声明，称已第一时间注意到相关网络信息，学校高度重视，已成立由纪委、人事处、研究生院组成的专项调查组，将依规依纪从严从快处理。声明还表示，在调查期间，已暂停该导师一切教学科研工作。',
    category: '吃瓜现场',
    categorySlug: 'chigua-xianchang',
    author: '社会观察员',
    date: '2026-06-29',
    image: 'https://readdy.ai/api/search-image?query=University%20campus%20building%20at%20night%20with%20dramatic%20lighting%2C%20dark%20academic%20atmosphere%2C%20warm%20amber%20street%20lights%2C%20editorial%20photography%20style%2C%20moody%20cinematic%20tone&width=800&height=500&seq=article-03&orientation=landscape',
    views: 2878900,
    isHot: true,
    tags: ['性骚扰', '实名举报', '高校', '录音证据'],
  },
  {
    id: '4',
    title: '某MCN机构内部聊天记录曝光：旗下网红全是剧本，连吵架都是演的',
    summary: '某头部MCN机构前员工爆料，公布大量内部群聊截图。记录显示该机构旗下多个"真实情侣"账号均为剧本演绎，包括分手、复合、出轨等情节都是提前编排好的。更惊人的是，评论区的水军互动也全部来自内部安排的"气氛组"。',
    content: '某拥有超五千万粉丝体量的头部MCN机构，日前被前员工爆出大量内部工作群聊天记录，揭露了该机构旗下多个头部账号的运营内幕。\n\n爆料人提供的截图来自该机构的"内容策划部"工作群，时间跨度长达八个月。群内对话清楚显示，多个以"真实情侣日常"为卖点的头部账号，其所有内容均为提前编排的剧本。\n\n截图内容令人咋舌：一段关于"情侣吵架"的视频，实际是策划部提前一周写好的脚本，包括吵架的台词、摔东西的顺序、甚至女主哭泣的时长都有精确要求。另一段"捉奸在床"的爆款视频，经过群内讨论后决定"再拍一条角度更好的"。\n\n更令网友愤怒的是，评论区那些"真情实感"的留言和互动，也全部来自机构内部的"气氛组"。截图显示，运营主管每天会在群内发布"今日评论任务"，要求每位运营人员用小号在指定视频下发布特定内容的评论。\n\n"我写过一个\'男友出轨闺蜜\'的剧本，结果视频爆了。很多粉丝私信我说自己也经历过同样的事，我只能默默道歉——你们真情实感追的，全是演的。"爆料人表示。\n\n目前该机构已关闭所有评论区，但未对此事作出任何正式回应。多个此前与该机构合作的品牌已紧急撤下相关推广内容。',
    category: '聊天记录',
    categorySlug: 'liaotian-jilu',
    author: '深度调查',
    date: '2026-06-28',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20chat%20messages%20with%20dramatic%20lighting%2C%20dark%20background%2C%20glowing%20text%20bubbles%2C%20warm%20orange%20and%20red%20accents%2C%20editorial%20photography%20style&width=800&height=500&seq=article-04&orientation=landscape',
    views: 4125600,
    isHot: true,
    tags: ['MCN机构', '剧本', '内部爆料', '聊天记录'],
  },
  {
    id: '5',
    title: '知名女主播线下见大哥，被偷拍视频疯传，本人哽咽回应',
    summary: '某平台头部女主播被曝私下与"榜一大哥"见面，酒店房间内被偷拍的视频在多个群组内疯狂传播。视频长度约12分钟，内容不堪入目。女主播在当晚直播中哽咽回应，称自己被欺骗，但网友并不买账。',
    content: '某直播平台头部女主播（直播间关注超800万）昨日被爆出与"榜一大哥"线下见面的偷拍视频，在多个社交群组和网盘中疯狂传播。\n\n据悉，该"榜一大哥"在直播间累计打赏超过200万元，长期占据该女主播的榜单首位。两人在线上互动频繁，大哥多次提出见面请求。据知情人士透露，女主播最终同意在某城市见面，并入住大哥预订的酒店。\n\n然而令女主播没想到的是，酒店房间内竟然隐藏了针孔摄像头。流出的视频画面显示，两人在房间内进行了长时间的亲密互动。视频画质虽然不高，但足以辨认出两人的面部特征。\n\n事件发酵后，该女主播于当晚开启直播进行回应。直播中她数度哽咽，表示自己"是被欺骗的"，"不知道对方会偷拍"。她还声称已经报警处理，并呼吁网友不要再传播视频。\n\n但直播间的评论区几乎一边倒地批评她："榜一大哥刷了200万，你说你不知道会发生什么？""直播装清纯，私下这么会玩？"\n\n目前该女主播的直播间已暂时停播，平台方表示正在调查核实相关情况。有律师分析指出，无论事件起因如何，偷拍和传播不雅视频的行为已经涉嫌违法。',
    category: '视频爆料',
    categorySlug: 'shipin-baoliao',
    author: '直播圈那些事',
    date: '2026-06-27',
    image: 'https://readdy.ai/api/search-image?query=Dark%20hotel%20room%20interior%20with%20dramatic%20red%20and%20orange%20ambient%20lighting%2C%20surveillance%20camera%20aesthetic%2C%20tense%20moody%20atmosphere%2C%20editorial%20photography%20style%2C%20cinematic%20composition&width=800&height=500&seq=article-05&orientation=landscape',
    views: 6789200,
    isHot: true,
    isNew: true,
    tags: ['女主播', '偷拍', '榜一大哥', '酒店'],
  },
  {
    id: '6',
    title: '某男星与女制片人深夜独处三小时，监控画面曝光引猜测',
    summary: '某当红男星被拍到深夜独自前往女制片人住所，在屋内停留近三小时后离开。两人此前被传在新戏选角过程中关系暧昧，此次被拍引发大量猜测。工作室紧急发声明否认，但网友扒出更多细节。',
    content: '某当红流量男星日前被知名狗仔拍到深夜前往某女制片人住所的画面，引发网络热议。\n\n据爆料视频显示，当晚11点左右，该男星乘坐一辆黑色商务车到达某高档小区。下车后他特意用连帽衫和口罩遮住面部，但在路灯下依然被认出。进入小区后，他直接乘坐电梯到达18楼某单位，在门口轻车熟路地输入密码进入。\n\n狗仔在楼下守候近三小时后，于次日凌晨2点左右拍到该男星匆忙离开的画面。离开时他的衣着与进入时明显不同，连帽衫已经脱下，露出里面的白色T恤。\n\n两人此前在新戏筹备期间就曾传出绯闻。有业内人士透露，该男星能拿下该剧男主一角，与这位女制片人的力荐密不可分。该剧总投资超2亿元，是今年的重点大项目。\n\n男星工作室在视频曝光后不到一小时就发布声明，称"当晚是为新剧剧本进行围读讨论，同在场还有导演和编剧共四人"。但网友很快指出，视频显示只有男星一人进出，且三小时内并无其他人到访。\n\n更有细心的网友扒出，该女制片人此前曾离婚两次，两任前夫均为娱乐圈人士。而她旗下的艺人中，有多位男星在与其"合作"后资源飞升。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '娱乐大侦探',
    date: '2026-06-26',
    image: 'https://readdy.ai/api/search-image?query=Night%20city%20apartment%20building%20exterior%20with%20dramatic%20lighting%2C%20dark%20urban%20atmosphere%2C%20warm%20window%20lights%2C%20moody%20cinematic%20tone%2C%20editorial%20photography%20style&width=800&height=500&seq=article-06&orientation=landscape',
    views: 3456700,
    tags: ['男星', '制片人', '深夜', '绯闻'],
  },
  {
    id: '7',
    title: '某富二代朋友圈炫富翻车，被扒出家产实为借贷，已被法院列为被执行人',
    summary: '社交平台知名炫富博主（自称某地产集团少东家）因一条朋友圈引发网友质疑，随后被扒出其"豪宅"实为租赁，"豪车"是租车行的日租车辆。更劲爆的是，企查查显示其已被多家法院列为失信被执行人，涉案金额超500万元。',
    content: '某社交平台拥有超300万粉丝的炫富博主"XX少爷"，日前因一条看似普通的朋友圈引发全网扒皮，最终人设彻底翻车。\n\n该博主的朋友圈日常充斥着豪宅、豪车、名表和奢华派对的内容。在他的描述中，自己是"某知名地产集团的少东家"，名下资产超十亿。他经常晒出的那栋位于市中心顶层复式豪宅，被他称为"日常居所"。\n\n事情的转折发生在三天前。该博主发布了一条在豪宅阳台上举办生日派对的照片，眼尖的网友发现窗外背景与某知名民宿平台上的房源图片完全一致。随后有人在该平台联系房东，确认该房源确实经常被"拍短视频的租客"预订。\n\n这一发现如同打开了潘多拉魔盒。网友们顺着线索继续深挖，发现博主日常晒出的多辆豪车均来自同一家高端汽车租赁公司。更讽刺的是，有网友在该租车行的直播间看到了博主"自己的"劳斯莱斯正在以每天8000元的价格对外出租。\n\n最劲爆的消息来自企查查平台。有网友查询发现，该博主的真名已被全国多家法院列为失信被执行人，涉及民间借贷、合同纠纷等多起案件，未履行金额累计超过500万元。其名下没有任何房产和车辆登记记录。\n\n目前该博主已经清空所有社交平台内容，账号显示"因违反社区规定被限制发布"。据悉，已有被他诈骗过的网友联合向公安机关报案。',
    category: '奇闻趣事',
    categorySlug: 'qiwen-qushi',
    author: '真相只有一个',
    date: '2026-06-25',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20faux%20aesthetic%2C%20empty%20luxury%20apartment%20interior%20with%20dramatic%20dark%20lighting%2C%20gold%20and%20orange%20accents%2C%20shallow%20and%20hollow%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=article-07&orientation=landscape',
    views: 1892300,
    tags: ['炫富翻车', '富二代', '失信被执行人', '人设崩塌'],
  },
  {
    id: '8',
    title: '某男团成员被爆队内霸凌，受害者晒伤情照片，公司已启动调查',
    summary: '某当红男团成员A被同队成员B爆料遭受长期霸凌，晒出了多张身体淤青照片和医院诊断证明。B称A仗着自己是"皇族"身份，经常以"练习指导"为由对其进行殴打和言语羞辱。所属公司发表声明，称已启动内部调查程序。',
    content: '某拥有千万级粉丝的偶像男团日前爆发队内霸凌丑闻。成员B在粉丝站发布长文，指控成员A长期对其实施霸凌行为，并晒出了多张身体淤青的照片以及某三甲医院出具的诊断证明。\n\n据B的描述，霸凌行为始于两年前的练习生时期。当时A被公司内定为"主推成员"，在训练和生活中拥有超越其他成员的特权。B称，A经常以"动作不标准""态度不认真"为由，在练习室里对他进行推搡、踢踹等行为。\n\n"最严重的一次，他直接用练习室的镜子碎片划破了我的手臂，缝了七针。"B晒出的照片显示，其手臂上有一道明显的手术疤痕，时间戳与B描述的事件吻合。\n\n更令粉丝愤怒的是，B还公布了多段练习室的录音。录音中可以清晰听到A用极其侮辱性的语言辱骂B，包括"你就是个废物""没有我你什么都不是""敢告状就让你退团"等内容。\n\n所属经纪公司于当日下午发布官方声明，表示已注意到相关指控，公司对此高度重视，已成立由法务部、艺人管理部、人力资源部组成的联合调查组。声明还承诺将在调查结束后第一时间公布结果，"绝不姑息任何违规行为"。\n\n该男团原定下周举办的粉丝见面会已宣布延期，多个代言品牌开始评估是否需要更换合作对象。',
    category: '吃瓜现场',
    categorySlug: 'chigua-xianchang',
    author: '偶像研究所',
    date: '2026-06-24',
    image: 'https://readdy.ai/api/search-image?query=Dark%20dance%20studio%20interior%20with%20dramatic%20spotlight%20lighting%2C%20shadowy%20figures%2C%20tense%20atmosphere%2C%20warm%20orange%20and%20red%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=article-08&orientation=landscape',
    views: 4234500,
    isHot: true,
    tags: ['男团', '霸凌', '队内冲突', '伤情照片'],
  },
  {
    id: '9',
    title: '某网红情侣分手大战升级！女方曝光男方欠条，男方直播爆女方整容前照片',
    summary: '某平台头部情侣账号宣布分手后，双方的互撕大战进入白热化阶段。女方晒出了男方签下的多张欠条，总额超80万元；男方则在直播中直接展示了女方整容前的照片和手术记录，并详细描述了其做过的项目。两人此前以"模范情侣"人设吸粉超千万。',
    content: '某平台坐拥超1200万粉丝的头部情侣账号"XX和XX"在宣布分手后，双方的互撕大战持续升级，每天都有新的猛料爆出。\n\n女方率先在直播中展示了男方在恋爱期间签下的多张手写欠条。据女方描述，男方以"投资创业""家里急用"等各种理由向她借钱，总金额超过80万元。"这些钱都是我一条一条视频拍出来的，他倒好，拿着我的钱去给别人花。"女方在直播中哭诉。\n\n欠条显示，最早的借款发生在2024年初，最近的则在今年4月。多张欠条上还有男方的身份证复印件和手印。女方表示将通过法律途径追讨欠款。\n\n男方则在当晚开启直播进行反击。直播中他展示了一组女方整容前的照片，与其现在的形象判若两人。他还公布了女方在某整形医院的手术记录，显示其做过双眼皮、隆鼻、下颌角、脂肪填充等多项手术，总花费约35万元。\n\n"她跟我在一起的时候说自己是纯天然，现在我才知道她脸上几乎没有原装的部位。"男方在直播中言辞激烈。他还爆料女方在恋爱期间多次与其他男性单独见面，"我早就知道，只是不想拆穿她"。\n\n两人的互撕引发网友站队大战。有人同情女方被借钱不还，也有人批评女方"花这么多钱整容骗感情"。目前双方均已删除此前账号中所有的甜蜜合照和情侣日常视频。',
    category: '网红爆料',
    categorySlug: 'wanghong-baoliao',
    author: '分手大战前线',
    date: '2026-06-23',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20confrontation%20scene%20with%20two%20silhouettes%20facing%20each%20other%2C%20dark%20moody%20atmosphere%2C%20warm%20orange%20and%20red%20accents%2C%20tension%20and%20conflict%2C%20editorial%20photography%20style&width=800&height=500&seq=article-09&orientation=landscape',
    views: 5123400,
    isHot: true,
    tags: ['情侣分手', '互撕', '欠条', '整容'],
  },
  {
    id: '10',
    title: '某带货主播售假被实锤，品牌方发声明追责，消费者集体起诉',
    summary: '拥有500万粉丝的带货主播"XX严选"被多名消费者联合举报售假。某国际奢侈品牌官方发布声明，称其直播间销售的产品并非正品，已委托律师团队进行追责。目前已有超过200名消费者联名向法院提起诉讼，要求退一赔三。',
    content: '某头部带货主播"XX严选"（粉丝量超500万）日前陷入售假风波，多名消费者联合举报其在直播间销售假冒奢侈品，引发舆论哗然。\n\n事情的导火索是一位职业打假人发布的检测报告。该打假人从"XX严选"直播间购买了一款售价8999元的某国际大牌包包，并将其送至专业鉴定机构进行检测。鉴定结果显示，该产品为高仿假货，与正品的材质、工艺、五金配件均存在明显差异。\n\n视频曝光后，迅速引发大量在直播间购买过商品的消费者跟进。多位消费者在评论区留言，表示从该直播间购买的护肤品、服饰、配饰等均存在质量问题。有人晒出了褪色的"金饰"、有人展示了开裂的"真皮"包包。\n\n事件发酵两天后，被假冒的国际奢侈品牌官方发布正式声明，明确表示"XX严选"直播间销售的产品与品牌无关，均为假冒伪劣产品。声明还表示已委托律师团队进行法律追责，要求该主播立即停止侵权行为并赔偿损失。\n\n目前，已有超过200名消费者联合向法院提起诉讼，依据《消费者权益保护法》要求"退一赔三"。据代理律师介绍，集体诉讼的总金额可能超过300万元。',
    category: '视频爆料',
    categorySlug: 'shipin-baoliao',
    author: '消费者权益',
    date: '2026-06-22',
    image: 'https://readdy.ai/api/search-image?query=Fake%20luxury%20products%20display%20with%20dramatic%20dark%20lighting%2C%20counterfeit%20handbags%20and%20accessories%2C%20warm%20orange%20and%20gold%20accents%2C%20editorial%20investigation%20style%2C%20moody%20atmosphere&width=800&height=500&seq=article-10&orientation=landscape',
    views: 2345600,
    tags: ['带货主播', '售假', '假货', '消费者维权'],
  },
  {
    id: '11',
    title: '某女艺人被曝当小三上位，原配晒出婚礼请柬和结婚证实锤',
    summary: '某二线女艺人被爆介入他人婚姻成功上位。原配（某企业高管妻子）在社交平台晒出结婚证、婚礼请柬以及丈夫与该女艺人的亲密合照，指控其明知对方已婚仍主动追求。该女艺人此前一直以"清纯独立女性"形象示人。',
    content: '某在多部网剧中担任女二号的二线女演员，日前被原配实名爆料介入他人婚姻，人设彻底崩塌。\n\n爆料人自称是某企业高管的合法妻子，两人于2019年举办婚礼，育有一子一女。她在社交平台晒出了两人的结婚证、婚礼请柬、全家福等照片，证明婚姻关系的真实性。\n\n"她在明知道我老公已婚的情况下，主动发送暧昧信息、约他出去吃饭。我老公一时糊涂，犯下了错误。但她不是受害者，她就是奔着上位来的。"原配在长文中写道。\n\n原配还晒出了丈夫与该女艺人的多张亲密合照，包括两人在餐厅十指相扣的照片、在海边度假的合影等。照片的时间戳显示，这些互动发生在该女艺人已经得知对方已婚身份之后。\n\n最令人震惊的是一段聊天记录。该女艺人在聊天中直接表示："你老婆就是个家庭主妇，她能给你什么？我能陪你走红毯、上综艺。"原配称这段对话是她从丈夫手机中偷偷截图保存的。\n\n该女艺人此前在综艺节目中多次强调自己是"独立的单身女性"，"不会靠男人"，还分享过"女性要自尊自爱"的言论。此次翻车导致其参与的待播综艺紧急删除其镜头，代言的某国产护肤品牌也已官宣终止合作。',
    category: '明星八卦',
    categorySlug: 'mingxing-bagua',
    author: '原配来了',
    date: '2026-06-21',
    image: 'https://readdy.ai/api/search-image?query=Wedding%20documents%20and%20photos%20scattered%20dramatically%20with%20dark%20moody%20lighting%2C%20broken%20trust%20theme%2C%20warm%20orange%20and%20red%20tones%2C%20editorial%20photography%20style%2C%20emotional%20atmosphere&width=800&height=500&seq=article-11&orientation=landscape',
    views: 3678900,
    tags: ['小三', '女艺人', '原配', '上位'],
  },
  {
    id: '12',
    title: '某游戏主播被爆开设赌博网站，后台数据截图显示流水超千万',
    summary: '某知名游戏主播被爆利用粉丝群体开设网络赌博平台。匿名爆料人提供了该主播名下网站的后台管理截图，显示注册用户数超3万人，累计投注流水超1200万元。该主播此前以"正能量游戏主播"形象走红，粉丝超600万。',
    content: '某头部游戏主播（粉丝超600万）日前被爆出利用其粉丝群体开设并运营网络赌博平台的惊天大瓜。\n\n爆料人自称是该平台的前技术人员，因"良心不安"选择曝光此事。他提供了多张据称是该赌博网站后台管理系统的截图，内容包括用户管理、投注记录、资金流水等核心数据。\n\n截图显示，该平台的注册用户数量超过3万人，其中绝大多数为18至25岁的年轻群体——正是该游戏主播的核心粉丝年龄段。累计投注流水高达1270余万元，平台抽水获利约180万元。\n\n更令人发指的是，该主播经常在直播中以"福利活动""粉丝专属"为名义，引导观众加入"私密粉丝群"。入群后，群管理员会私发赌博网站的链接和邀请码，并承诺"主播亲自带玩，稳赚不赔"。\n\n"他用自己在粉丝心中的信誉做担保，让很多未成年人觉得这是合法的。有粉丝在群里说输了生活费，他居然回复\'下次带你翻本\'。"爆料人表示。\n\n目前，已有网友向国家网信办和当地公安机关进行举报。法律界人士指出，组织网络赌博属于刑事犯罪，最高可判处十年有期徒刑。该主播的直播间已于昨日被平台封禁，但本人尚未作出任何回应。',
    category: '视频爆料',
    categorySlug: 'shipin-baoliao',
    author: '游戏圈纪检',
    date: '2026-06-20',
    image: 'https://readdy.ai/api/search-image?query=Computer%20screen%20showing%20gambling%20website%20interface%20with%20dramatic%20dark%20lighting%2C%20data%20dashboard%20with%20numbers%2C%20warm%20orange%20and%20red%20warning%20accents%2C%20editorial%20investigation%20style&width=800&height=500&seq=article-12&orientation=landscape',
    views: 4567800,
    isHot: true,
    tags: ['游戏主播', '赌博', '后台数据', '犯罪'],
  },
];

export function getHotArticles(count: number = 6): Article[] {
  return articles.filter((a) => a.isHot).slice(0, count);
}

export function getNewArticles(count: number = 6): Article[] {
  return articles.filter((a) => a.isNew).slice(0, count);
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(currentId: string, categorySlug: string, count: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== currentId && a.categorySlug === categorySlug)
    .slice(0, count);
}